/* eslint-disable */
import BlankLayout from '@core/layouts/BlankLayout'
import '@core/scss/base/pages/page-auth.scss'
import * as configActions from 'actions/config'
import * as userActions from 'actions/user'
import InputPasswordToggle from 'components/InputPasswordToogle'
import useQuery from 'hooks/useQuery'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Button, Card, CardBody, CardTitle, Form, FormGroup, Input, Label } from 'reactstrap'
import { handleLogin, handleVerifyTwoFactor } from './services'

function Login() {
  const querys = useQuery()
  const [form, setForm] = useState({
    email: '',
    password: ''
  })
  const [loading, setLoading] = useState<boolean>(false)
  const [twoFactor, setTwoFactor] = useState<{ email: string, expiresAt: string } | null>(null)
  const [twoFactorCode, setTwoFactorCode] = useState('')
  const dispatch = useDispatch()

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value })
  }

  const onSubmitLogin = async (e: React.SyntheticEvent) => {
    e.preventDefault()
    const callback = (email:string) => {
      dispatch(configActions.listConfig())
      dispatch(userActions.setAuthenticated(true, email))
    }
  
    handleLogin({
      setLoading,
      form,
      callback,
      twoFactorCallback: setTwoFactor,
    })
  }

  const onSubmitTwoFactor = async (e: React.SyntheticEvent) => {
    e.preventDefault()
    if (!twoFactor) return

    const callback = (email:string) => {
      dispatch(configActions.listConfig())
      dispatch(userActions.setAuthenticated(true, email))
    }

    handleVerifyTwoFactor({
      setLoading,
      email: twoFactor.email,
      code: twoFactorCode,
      callback,
    })
  }

  const returnToLogin = () => {
    setTwoFactor(null)
    setTwoFactorCode('')
  }

  useEffect(() => {
    if(querys.get('expired') === '1') {
      toast.error('Su sesión ha expirado')
    }
  }, [])

  return (
    <BlankLayout>
      <div className='auth-wrapper auth-v1 px-2'>
        <div className='auth-inner py-2'>
          <Card className='mb-0'>
            <CardBody>
              <Link className='brand-logo' to='/' onClick={e => e.preventDefault()}>
                <h2 className='brand-text text-primary'>Fluyez</h2>
              </Link>
              <CardTitle tag='h4' className='mb-1'>
                Fluyez Admin
              </CardTitle>
              {!twoFactor ? (
                <Form className='auth-login-form mt-2' onSubmit={onSubmitLogin}>
                  <FormGroup>
                    <Label className='form-label' for='login-email'>
                      Email
                    </Label>
                    <Input type='email' name='email' id='login-email' placeholder='john@example.com' autoFocus onChange={onChange} />
                  </FormGroup>
                  <FormGroup>
                    <div className='d-flex justify-content-between'>
                      <Label className='form-label' for='login-password'>
                        Contraseña
                      </Label>
                    </div>
                    <InputPasswordToggle name='password' className='input-group-merge' id='login-password' onChange={onChange} visible={false} />
                  </FormGroup>
                  <Button type='submit' color='primary' block disabled={loading}>
                    {loading ? 'Validando...' : 'Iniciar Sesión'}
                  </Button>
                </Form>
              ) : (
                <Form className='auth-login-form mt-2' onSubmit={onSubmitTwoFactor}>
                  <p className='text-muted'>
                    Enviamos un código de verificación a <strong>{twoFactor.email}</strong>.
                  </p>
                  <FormGroup>
                    <Label className='form-label' for='login-two-factor-code'>
                      Código de verificación
                    </Label>
                    <Input
                      type='text'
                      name='twoFactorCode'
                      id='login-two-factor-code'
                      inputMode='numeric'
                      autoComplete='one-time-code'
                      maxLength={6}
                      pattern='[0-9]{6}'
                      value={twoFactorCode}
                      autoFocus
                      onChange={e => setTwoFactorCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                    />
                    <small className='form-text text-muted'>El código es válido durante 10 minutos.</small>
                  </FormGroup>
                  <Button type='submit' color='primary' block disabled={loading || twoFactorCode.length !== 6}>
                    {loading ? 'Verificando...' : 'Verificar código'}
                  </Button>
                  <Button type='button' color='link' block onClick={returnToLogin} disabled={loading}>
                    Volver al inicio de sesión
                  </Button>
                </Form>
              )}
            </CardBody>
          </Card>
        </div>
      </div>
    </BlankLayout>
  )
}

export default Login
